<template>
    <Transition name="modal" :duration="{ enter: 3000, leave: 300 }">
        <div class="modal menu-modal" v-if="$store.state.app.displayNav">
            <div class="inner">
                <div class="content-modal">
                    <div id="nav">
                        <div class="container">
                            <a href="./">
                                <IconHaikara color="#fff" class="logo" />
                            </a>
                            <span @click="displayNav">
                                <Close color="#fff" class="close" />
                            </span>
                        </div>

                        <div class="container">
                            <nav class="menu">
                                <ul>
                                    <li>
                                        <a href="./">{{ $t("message.home") }}</a>
                                    </li>
                                    <li>
                                        <a href="agence">{{ $t("message.agency") }}</a>
                                    </li>
                                    <li>
                                        <a href="references">{{ $t("message.refs") }}</a>
                                    </li>
                                    <!--<li>
                                        <a href="technos">{{ $t("message.technos") }}</a>
                                    </li>-->
                                    <li>
                                        <a href="formavisa">{{ $t("message.harkhan") }}</a>
                                    </li>
                                    <!--<li>
                                        <a href="lab">{{ $t("message.lab") }}</a>
                                    </li>-->
                                    <li>
                                        <span @click="goToFormContact">{{ $t("message.contact") }}</span>
                                    </li>
                                </ul>
                            </nav>
                        </div>

                        <div class="container">
                            <div>
                                <a href="https://www.linkedin.com/company/haikara" target="_blank">
                                    <Linkedin class="linkedin" />
                                </a>
                            </div>
                            <div>
                                <!--<LocaleChanger />-->
                            </div>
                            <div>
                                <span> ©2005-{{ new Date().getFullYear() }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Transition>
</template>

<script>
import LocaleChanger from "./LocaleChanger.vue";
import Close from "./img/Close.vue";
import Linkedin from "./img/Linkedin.vue";
import IconHaikara from "./img/IconHaikara.vue";

export default {
    name: "Nav",
    data: function () {
        return {};
    },
    components: {
        IconHaikara,
        Close,
        Linkedin,
        LocaleChanger,
    },
    watch: {
        "$store.state.app.displayNav": function (display) {
            if (display) document.body.classList.add("hidden");
            else document.body.classList.remove("hidden");
        },
    },
    methods: {
        goToFormContact: function () {
            const el = document.getElementById("contact");
            if (el) {
                const y = el.getBoundingClientRect().top + window.scrollY;
                window.scrollTo({ top: y, behavior: "smooth" });
            }

            this.$store.dispatch("app/displayNav", false);
        },
        displayNav: function () {
            this.$store.dispatch("app/displayNav", false);
        },
    },
};
</script>

<style scoped lang="scss">
.menu-modal {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 999;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    width: 100vw;

    .inner {
        height: 800vh;
        width: 800vh;
        border-radius: 50%;
        position: absolute;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: red;

        .content-modal {
            position: fixed;
            top: 0;
            bottom: 0;
            left: 0;
            right: 0;

            height: 100%;
            width: 100vw;
            overflow-y: auto;
            opacity: 1;
        }
    }
}

#nav {
    display: flex;
    flex-flow: column;
    align-items: center;
    justify-content: center;
    min-height: 100%;
    width: 100vw;

    > div {
        &:first-child {
            display: flex;
            align-items: center;
            justify-content: space-between;
            height: 100px;
            flex: 0 0 100px;

            .logo {
                width: 74px;
            }

            .close {
                height: 40px;
                cursor: pointer;
            }
        }

        &:nth-child(2) {
            flex: 1;
            display: flex;
            align-items: center;
            justify-content: center;
        }

        &:last-child {
            display: flex;
            align-items: center;
            justify-content: space-between;
            height: 100px;
            flex: 0 0 100px;
            font-size: 1.8rem;
            color: #fff;
            font-weight: 700;

            > div {
                &:first-child {
                    flex: 1;
                    text-align: left;
                }

                &:nth-child(2) {
                    flex: 2;
                    text-align: center;
                }

                &:last-child {
                    flex: 1;
                    text-align: right;
                }
            }

            .linkedin {
                height: 70px;
                width: auto;
            }
        }
    }
}

.menu {
    ul {
        list-style: none;
        margin: 0;
        padding: 0;
    }

    span,
    a {
        text-transform: uppercase;
        font-size: 3rem;
        font-weight: 900;
        text-decoration: none;
        color: #fff;
        transition: all 0.4s;
        cursor: pointer;

        &:hover,
        &:focus {
            color: #000;
        }
    }
}

// Animation modal
.modal-enter-active,
.modal-leave-active {
    transition: all 0.3s ease-in-out;

    .inner {
        transition: all 1s ease-in-out;
        transition-delay: 0.3s;

        .content-modal {
            transition: all 0.4s;
            transition-delay: 1s;
            overflow-y: hidden;
        }
    }
}

.modal-enter-from,
.modal-leave-to {
    opacity: 0;

    .inner {
        height: 0;
        width: 0;

        .content-modal {
            opacity: 0;
        }
    }
}

@media (max-width: 1200px) {
    #nav {
        > div {
            &:first-child {
                height: 100px;
                flex: 0 0 100px;

                .logo {
                    width: 70px;
                }

                .close {
                    height: 40px;
                }
            }

            &:last-child {
                height: 100px;
                flex: 0 0 100px;
                font-size: 1.6rem;

                .linkedin {
                    height: 55px;
                }
            }
        }
    }

    .menu {
        span,
        a {
            font-size: 2.5rem;
        }
    }
}

@media (max-width: 992px) {
}

@media (max-width: 768px) {
    #nav {
        > div {
            &:first-child {
                height: 80px;
                flex: 0 0 80px;

                .logo {
                    width: 60px;
                }

                .close {
                    height: 40px;
                }
            }

            &:last-child {
                height: 80px;
                flex: 0 0 80px;
                font-size: 1.2rem;

                .linkedin {
                    height: 45px;
                }
            }
        }
    }

    .menu {
        span,
        a {
            font-size: 2.4rem;
        }
    }
}

@media (max-width: 576px) {
    #nav {
        > div {
            &:first-child {
                height: 80px;
                flex: 0 0 80px;

                .logo {
                    width: 60px;
                }

                .close {
                    height: 40px;
                }
            }

            &:last-child {
                height: 80px;
                flex: 0 0 80px;
                font-size: 1rem;

                .linkedin {
                    height: 45px;
                }

                > div:nth-child(2) {
                    flex: 1;
                }
            }
        }
    }

    .menu {
        span,
        a {
            font-size: 2rem;
        }
    }
}

@keyframes opacity-in {
    100% {
        opacity: 1;
    }
}

@keyframes opacity-out {
    100% {
        opacity: 0;
    }
}
</style>
